module.exports = __webpack_public_path__ + "img/TRIUMPH.bd3f9c6.jpg";